export default __webpack_public_path__ + "static/media/Screenshot (1073).e057e884.png";